class ComparisonTable extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.lastScrollTop = 0; // Track last scroll position
    this.setupScrollBehavior();
  }

  init() {
    this.setupAccordion();
    this.setupTooltips();
    this.setupShowMore();
  }

  setupScrollBehavior() {
    const header = this.querySelector(".comparison-table__header");
    const mobileMediaQuery = window.matchMedia("(max-width: 989px)");

    const updateHeaderPosition = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isMobile = mobileMediaQuery.matches;

      // Determine scroll direction and apply appropriate position
      if (scrollTop > this.lastScrollTop) {
        // Scrolling DOWN
        header.style.top = isMobile ? "-100px" : "0";
      } else {
        // Scrolling UP
        header.style.top = isMobile ? "-34px" : "70px";
      }

      this.lastScrollTop = scrollTop;
    };

    // Listen for scroll events
    window.addEventListener("scroll", updateHeaderPosition);

    // Listen for resize events to handle switching between mobile and desktop
    mobileMediaQuery.addListener(updateHeaderPosition);
  }

  setupAccordion() {
    const headers = this.querySelectorAll("[data-group-header='true']");
    headers.forEach((button) => {
      button.addEventListener("click", () => {
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", !isExpanded);
        const content = button.nextElementSibling;
        content.setAttribute("aria-hidden", isExpanded);
        button.closest(".comparison-table__group").classList.toggle("comparison-table__group--closed", isExpanded);

        // Toggle visibility
        if (isExpanded) {
          content.style.maxHeight = null; // Collapse
          content.style.opacity = "0"; // Fade out
          content.style.visibility = "hidden"; // Hide
        } else {
          content.style.maxHeight = content.scrollHeight + "px"; // Expand
          content.style.opacity = "1"; // Fade in
          content.style.visibility = "visible"; // Show
        }
      });
    });
  }

  setupShowMore() {
    const showMoreButton = this.querySelector("[data-show-more='true']");
    if (showMoreButton) {
      showMoreButton.addEventListener("click", () => {
        this.querySelector(".comparison-table__body").classList.add("comparison-table__body--expanded");
        showMoreButton.remove();
      });
    }
  }

  setupTooltips() {
    const tooltipTriggers = this.querySelectorAll(".comparison-table__tooltip-trigger");
    tooltipTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        const tooltip = trigger.nextElementSibling;
        const isVisible = tooltip.getAttribute("aria-hidden") === "false";

        // Hide all tooltips
        this.querySelectorAll(".comparison-table__custom-tooltip").forEach((t) => {
          t.setAttribute("aria-hidden", "true");
          t.style.opacity = "0";
          t.style.visibility = "hidden";
        });

        // Toggle the clicked tooltip
        tooltip.setAttribute("aria-hidden", isVisible);
        tooltip.style.opacity = isVisible ? "0" : "1";
        tooltip.style.visibility = isVisible ? "hidden" : "visible";
      });
    });

    // Close tooltip when clicking outside
    document.addEventListener("click", (event) => {
      if (!event.target.matches(".comparison-table__tooltip-trigger")) {
        this.querySelectorAll(".comparison-table__custom-tooltip").forEach((t) => {
          t.setAttribute("aria-hidden", "true");
          t.style.opacity = "0";
          t.style.visibility = "hidden";
        });
      }
    });

    document.querySelectorAll(".comparison-table__tooltip-trigger").forEach((trigger) => {
      trigger.addEventListener("mouseenter", handleTooltipPosition);
      trigger.addEventListener("focus", handleTooltipPosition);
    });

    function handleTooltipPosition(event) {
      const tooltip = event.target.nextElementSibling;
      if (!tooltip) return;

      // Reset classes
      tooltip.classList.remove("comparison-table__custom-tooltip--right", "comparison-table__custom-tooltip--left");

      // Get tooltip dimensions and position
      const tooltipRect = tooltip.getBoundingClientRect();
      const triggerRect = event.target.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      // Check if tooltip would overflow right side
      if (triggerRect.left + tooltipRect.width / 2 > viewportWidth - 20) {
        tooltip.classList.add("comparison-table__custom-tooltip--right");
      }
      // Check if tooltip would overflow left side
      else if (triggerRect.left - tooltipRect.width / 2 < 20) {
        tooltip.classList.add("comparison-table__custom-tooltip--left");
      }
    }

    // Add resize handler to reposition tooltips if needed
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const visibleTooltip = document.querySelector(
          '.comparison-table__custom-tooltip[style*="visibility: visible"]'
        );
        if (visibleTooltip) {
          const trigger = visibleTooltip.previousElementSibling;
          if (trigger) {
            handleTooltipPosition({ target: trigger });
          }
        }
      }, 100);
    });
  }
}

if (!customElements.get("comparison-table")) {
  customElements.define("comparison-table", ComparisonTable);
}
